<template>
    <div class="out-div">
        <div class="card-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div>
        <div class="major-query-container" id="outZhiyeDiv" ref="outZhiyeDiv">
        <div class="major-panel" id="loadZyData">
            <div class="major-types">
                <!-- <div class="major-type-name">
                    <span class="xz-type" :class="{blue:xz === 0}" @click="changeStatus(0)">本科</span>
                    <span class="xz-type" :class="{blue:xz === 1}" @click="changeStatus(1)">专科</span>
                </div> -->
                <template v-if="searchList.length===0||(searchList.size&&searchList.size===0)">
                    <div class="major-type-group" v-for="(item,index) in majorList" :key="index">
                    <a href="javascript:void(0)" class="major-one"><span>{{item.zymc}}</span>
                    <i class="el-icon-arrow-right major-one-right"></i>
                    </a>
                    </div>
                </template>
                <template v-if="searchList.length>0||(searchList.size&&searchList.size>0)">
                    <template v-if="searchList.leftMajor">
                    <div class="major-type-group" v-for="(item,index) in searchList.leftMajor" :key="index">
                    <a href="javascript:void(0)" class="major-one"><span>{{item.zymc}}</span>
                    <i class="el-icon-arrow-right major-one-right"></i>
                    </a>
                    </div>
                    </template>
                </template>
                <template v-if="vocationList.size&&vocationList.size>0">
                    <template v-if="vocationList.leftVocation">
                        <div class="major-type-group" v-for="(item,index) in vocationList.leftVocation" :key="index"
                        @click="goAnchor(item.vocationCode)">
                            <a href="javascript:void(0)" class="major-one" style="box-sizing: content-box;">
                                <span style="display: block;width: 240px;margin-right: 10px;">{{item.vocationName}}</span>
                            <i class="el-icon-arrow-right major-one-right"></i>
                            </a>
                        </div>
                    </template>
                </template>
            </div>
            <div>
                <div class="major-search">
                    <input type="text" placeholder="请输入要查询的职业名称" class="search" v-model="zymc"/>
                    <button  class="search-btn" @click="searchVocation"><i class="el-icon-search"></i></button>
                </div>
                <div class="split-line">共找到 <i style="color:#FF0000">
                    <template v-if="searchList.length===0||(searchList.size&&searchList.size===0)">
                        {{size}}
                    </template>
                    <template v-if="searchList.length>0||(searchList.size&&searchList.size>0)">
                        {{searchSize}}
                    </template>
                <!-- </i>个{{ xz==0?'本科':'专科' }}专业</div> -->
                </i>个职业</div>
                <div class="major-group">
                    <template v-if="searchList.length===0||(searchList.size&&searchList.size===0)">
                        <div class="major-item" ref="typeName" v-for="(item,index) in majorList" :key="index" :id="'type'+xz+index+1">
                        <div class="major-item-title"><div class="line"></div> {{item.zymc}}</div>
                        <div class="pro_msg">
                            <span v-for="(item2,i2) in [1,2,3,4,5,6,7,8,9,10,11,12,13,14
                            ,15,16,17,18,19,20,21,22,23,24,25,
                            26,27,28,29,30,31,32]" :key="i2">
                            <template v-if="item['list'+item2]">
                            <div style="padding:10px 0;"></div>
                            <span
                            v-for="(major,index2) in item['list'+item2]"
                            :key="index2+major.zydm"
                            class="major-name"
                            >
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length===4" class="bluexx"
                            >{{major.zymc}}</a>
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length===5" class="puplexx"
                            >{{major.zymc}}</a>
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length!==4&&major.zydm.length!==5"
                            >{{major.zymc}}</a>
                            </span>
                            </template>
                            </span>
                        </div>
                    </div>
                    </template>
                    <template v-if="searchList.length>0||(searchList.size&&searchList.size>0)">
                        <template v-if="searchList.rightMajor">
                        <div class="major-item" ref="typeName" v-for="(item,index) in searchList.rightMajor" :key="index" :id="'type'+xz+index+1">
                        <div class="major-item-title"><div class="line" style="box-sizing: content-box;"></div> {{item.zymc}}</div>
                        <div class="pro_msg">
                            <span v-for="(item2,i2) in
                            [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,
                            20,21,22,23,24,25,26,27,28,29,31,32]" :key="i2">
                            <template v-if="item['list'+item2]">
                            <div style="padding:10px 0;"></div>
                            <span
                            v-for="(major,index2) in item['list'+item2]"
                            :key="index2+major.zydm"
                            class="major-name"
                            >
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length===4" class="bluexx"
                            >
                            <span>{{major.zyzd1}}</span>
                            <span style="color:red">{{major.zyzd2}}</span>
                            <span>{{major.zyzd3}}</span>
                            </a>
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length===5" class="puplexx"
                            >
                            <span>{{major.zyzd1}}</span>
                            <span style="color:red">{{major.zyzd2}}</span>
                            <span>{{major.zyzd3}}</span>
                            </a>
                            <a :zy-zyid="major.zydm" v-if="major.zydm.length!==4&&major.zydm.length!==5"
                            >
                            <span>{{major.zyzd1}}</span>
                            <span style="color:red">{{major.zyzd2}}</span>
                            <span>{{major.zyzd3}}</span>
                            </a>
                            </span>
                            </template>
                            </span>
                        </div>
                        </div>
                        </template>
                        <template v-if="majorInList.length>0">
                            <div class="major-item" ref="typeName" v-for="(item,index) in majorInList" :key="index" :id="'type'+xz+index+1">
                            <div class="major-item-title"><div class="line"></div> {{item.zymc}}</div>
                            <div class="pro_msg">
                                <span v-for="(item2,i2) in [1,2,3,4,5,6,7,8,9,10,11,12,13,14
                                ,15,16,17,18,19,20,21,22,23,24,25,
                                26,27,28,29,30,31,32]" :key="i2">
                                <template v-if="item['list'+item2]">
                                <div style="padding:10px 0;"></div>
                                <span
                                v-for="(major,index2) in item['list'+item2]"
                                :key="index2+major.zydm"
                                class="major-name"
                                >
                                <a :zy-zyid="major.zydm" v-if="major.zydm.length===4" class="bluexx"
                                >{{major.zymc}}</a>
                                <a :zy-zyid="major.zydm" v-if="major.zydm.length===5" class="puplexx"
                                >{{major.zymc}}</a>
                                <a :zy-zyid="major.zydm" v-if="major.zydm.length!==4&&major.zydm.length!==5"
                                >{{major.zymc}}</a>
                                </span>
                                </template>
                                </span>
                            </div>
                            </div>
                        </template>
                    </template>
                    <template v-if="vocationList.length===0||(vocationList.size&&vocationList.size>0)">
                        <template v-if="vocationList.rightVocation">
                            <div class="major-item" ref="typeName" v-for="(item,index) in vocationList.rightVocation"
                            :key="index" :id="'type'+xz+index+1">
                                <div class="major-item-title" style="box-sizing: content-box;"><div class="line"></div> {{item.vocationName}}</div>
                                <div class="pro_msg">
                                    <span v-for="(item2,i2) in [1,2,3,4,5,6,7,8,9,10,11,12,13,14
                                    ,15,16,17,18,19,20,21,22,23,24,25,
                                    26,27,28,29,30,31,32]" :key="i2">
                                    <template v-if="item['list'+item2]">
                                    <div style="padding:10px 0;"></div>
                                    <span
                                    v-for="(vocation,index2) in item['list'+item2]"
                                    :key="index2+vocation.vocationCode"
                                    class="major-name"
                                    >
                                    <a :zy-zyid="vocation.vocationCode" v-if="vocation.vocationCode.length===5" class="bluexx"
                                    >{{vocation.vocationName}}</a>
                                    <a :zy-zyid="vocation.zydm" v-if="vocation.vocationCode.length!==5"
                                    >{{vocation.vocationName}}</a>
                                    </span>
                                    </template>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
</template>
<script>
import {mapState} from "vuex";
export default {
data(){
    return {
        majorTypes:[
            {majorType:"哲学"},
            {majorType:"经济学"}
        ],
        zymc:"",
        searchList:[],
        majorInList:[],
        searchSize:0,
        majorList:[],
        xz:0,
        size:0,
        vocationList:[]
    };
},
methods:{
    // 获取职业列表
    async getVocationList(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("outZhiyeDiv"),text:'正在加载中'});
        const res=await this.$http.getHttp("/career/getCareerList");
        console.log(res);
        if(res.status===200&&res.data&&res.data.length>0){
            const zhiYeArr=[...res.data];
            const arr={leftVocation:[],rightVocation:[]};
            for(let i=0;i<zhiYeArr.length;i++){
                if(zhiYeArr[i]){
                    arr.leftVocation.push({vocationName:zhiYeArr[i].firName,vocationCode:zhiYeArr[i].firCode+""});
                    const secondVocations=zhiYeArr[i].secList;
                    for(let j=0;j<secondVocations.length;j++){
                        const obj={};
                        obj.firstVocationName=zhiYeArr[i].firName;
                        obj.firstVocationCode=zhiYeArr[i].firCode+"";
                        if(secondVocations[j]){
                            obj.vocationName=secondVocations[j].secName;
                            obj.vocationCode=secondVocations[j].secCode+"";
                            const thirdVocations=secondVocations[j].thiList;
                            let count=1;
                            for(let k=0;k<thirdVocations.length;k++){
                                if(!obj["list"+count]){
                                    obj["list"+count]=[];
                                    if(thirdVocations[k]){
                                        obj["list"+count].push({
                                            vocationName:thirdVocations[k].thiName,
                                            vocationCode:thirdVocations[k].thiCode+""
                                        });
                                        const fouthVocations=thirdVocations[k].forList;
                                        for(let l=0;l<fouthVocations.length;l++){
                                            if(fouthVocations[l]){
                                                obj["list"+count].push({
                                                    vocationName:fouthVocations[l].forName,
                                                    vocationCode:fouthVocations[l].forCode+""
                                                });
                                            }
                                        }
                                        count++;
                                    }
                                }else{
                                    if(thirdVocations[k]){
                                        obj["list"+count].push({
                                            vocationName:thirdVocations[k].thiName,
                                            vocationCode:thirdVocations[k].thiCode+""
                                        });
                                        const fouthVocations=thirdVocations[k].forList;
                                        for(let l=0;l<fouthVocations.length;l++){
                                            if(fouthVocations[l]){
                                                obj["list"+count].push({
                                                    vocationName:fouthVocations[l].forName,
                                                    vocationCode:fouthVocations[l].forCode+""
                                                });
                                            }
                                        }
                                        count++;
                                    }
                                }
                            }
                            arr.rightVocation.push(obj);
                        }
                    }
                }
            }
            let size=0;
            for(let i=0;i<arr.rightVocation.length;i++){
                const obj=arr.rightVocation[i];
                for(let j=1;j<33;j++){
                    if(obj["list"+j]){
                        for(let k=0;k<obj["list"+j].length;k++){
                            size++;
                        }
                    }
                }
            }
            arr.size=size;
            console.log(arr);
            this.size=size;
            this.vocationList=arr;
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
        loading.close();
    },
    goAnchor(firstVocationCode){
        const obj=this.vocationList;
        let index=0;
        for(let i=0;i<obj.rightVocation.length;i++){
            console.log(obj.rightVocation[i].firstVocationCode,i,firstVocationCode);
            if(obj.rightVocation[i].firstVocationCode===firstVocationCode){
                index=i;
                break;
            }
        }
        const selector='type'+this.xz+ index+1;
        const anchor = document.getElementById(selector);// 参数为要跳转到的元素id
            document.body.scrollTop = anchor.offsetTop; // chrome
            document.documentElement.scrollTop = anchor.offsetTop; // firefox
    },
    async searchVocation(){
        const vocationName=this.zymc;
        if(vocationName===""){
            await this.getVocationList();
        }else{
            const res=await this.$http.getHttp("/career/getCareerList?career="+vocationName);
        console.log(res);
        if(res.status===200&&res.data&&res.data.length>0){
            const zhiYeArr=[...res.data];
            const arr={leftVocation:[],rightVocation:[]};
            for(let i=0;i<zhiYeArr.length;i++){
                if(zhiYeArr[i]){
                    arr.leftVocation.push({vocationName:zhiYeArr[i].firName,vocationCode:zhiYeArr[i].firCode+""});
                    const secondVocations=zhiYeArr[i].secList;
                    for(let j=0;j<secondVocations.length;j++){
                        const obj={};
                        obj.firstVocationName=zhiYeArr[i].firName;
                        obj.firstVocationCode=zhiYeArr[i].firCode+"";
                        if(secondVocations[j]){
                            obj.vocationName=secondVocations[j].secName;
                            obj.vocationCode=secondVocations[j].secCode+"";
                            const thirdVocations=secondVocations[j].thiList;
                            let count=1;
                            for(let k=0;k<thirdVocations.length;k++){
                                if(!obj["list"+count]){
                                    obj["list"+count]=[];
                                    if(thirdVocations[k]){
                                        obj["list"+count].push({
                                            vocationName:thirdVocations[k].thiName,
                                            vocationCode:thirdVocations[k].thiCode+""
                                        });
                                        const fouthVocations=thirdVocations[k].forList;
                                        for(let l=0;l<fouthVocations.length;l++){
                                            if(fouthVocations[l]){
                                                obj["list"+count].push({
                                                    vocationName:fouthVocations[l].forName,
                                                    vocationCode:fouthVocations[l].forCode+""
                                                });
                                            }
                                        }
                                        count++;
                                    }
                                }else{
                                    if(thirdVocations[k]){
                                        obj["list"+count].push({
                                            vocationName:thirdVocations[k].thiName,
                                            vocationCode:thirdVocations[k].thiCode+""
                                        });
                                        const fouthVocations=thirdVocations[k].forList;
                                        for(let l=0;l<fouthVocations.length;l++){
                                            if(fouthVocations[l]){
                                                obj["list"+count].push({
                                                    vocationName:fouthVocations[l].forName,
                                                    vocationCode:fouthVocations[l].forCode+""
                                                });
                                            }
                                        }
                                        count++;
                                    }
                                }
                            }
                            arr.rightVocation.push(obj);
                        }
                    }
                }
            }
            let size=0;
            for(let i=0;i<arr.rightVocation.length;i++){
                const obj=arr.rightVocation[i];
                for(let j=1;j<33;j++){
                    if(obj["list"+j]){
                        for(let k=0;k<obj["list"+j].length;k++){
                            size++;
                        }
                    }
                }
            }
            arr.size=size;
            console.log(arr);
            this.size=size;
            this.vocationList=arr;
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
        }

    }
},
computed:{
    ...mapState(["userInfo"])
},
async mounted(){
    // const leftArr=[];
    // for(let i=0;i<8;i++){
    //     leftArr.push({zymc:"xxx"});
    // }
    // this.majorList=leftArr;
    await this.getVocationList();
}
}
</script>
<style lang="less" scoped>
.out-div{
    width: 1100px;
    margin: 0 auto;
.card-top{
        width: 1100px;
        margin: 20px auto;
}
.major-query-container{
    min-width:1200px;
    margin:0 auto;
    min-height:calc(100vh - 380px);
    min-height:-moz-calc(100vh - 380px);
    min-height:-webkit-calc(100vh - 380px);
    .major-panel{
        width: 1200px;
        box-sizing: border-box;
        padding: 16px;
        margin: 0 auto;
        display: flex;
        background-color: #fff;
        .major-types{
            width: 310px;
            height: 800px;
            margin: 0 20px 0;
            box-sizing: border-box;
            border: 1px solid #dcdfe6;
            .major-type-name{
                font-size: 18px;
                height: 40px;
                color: #fff;
                background-color: hsla(60,1%,60%,.471);
                line-height: 40px;
                .xz-type{
                    display: inline-block;
                    width: 101px;
                    height: 100%;
                    text-align: center;
                    cursor: pointer;
                }
                .blue{
                    background-color: #5ba8ff;
                }
            }
            .major-type-group{
                // font-size: 18px;
                // height: 40px;
                // color: #fff;
                // background-color: hsla(60,1%,60%,.471);
                // line-height: 40px;
                .major-one{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 35px;
                    padding: 2px 0;
                    margin: 0 10px;
                    font-size: 14px;
                    color: #303133;
                    border-bottom: 1px solid #dcdfe6;
                }
                .major-one:hover{
                    color:#ff861a;
                }
            }
        }
        .major-search{
            display: flex;
            flex-direction: row;
            width: 810px;
            margin: 0 auto;
            .search{
                box-sizing: border-box;
                width: 710px;
                height: 40px;
                padding-left: 10px;
                border: 2px solid #f4a460;
                border-right: none;
                color: #606266;
            }
            .search-btn{
                width: 100px;
                color: #fff;
                height: 40px;
                border: 1px solid #f4a460;
                padding-left: -1px;
                font-size: 18px;
                cursor: pointer;
                background-color: #f4a460;
            }
        }
        .split-line{
            border: 0;
            width: 810px;
            margin: 20px auto;
            color: #666;
            text-align: right;
            background-image: linear-gradient(90deg,rgba(244,164,96,.1),rgba(244,164,96,.75),rgba(244,164,96,.1));
        }
        .major-group{
            width: 810px;
            margin: 0 auto;
            box-sizing: border-box;
            .major-item{
                display: inline-block;
                width: 100%;
                line-height: 40px;
                font-size: 14px;
                color: #666;
                .major-item-title{
                    display: flex;
                    align-items: center;
                    height: 40px;
                    margin-top: 20px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #ff861a;
                    border-bottom: 1px solid #e4e7ed;
                    background-color: #f8f8f8;
                    .line{
                        width: 0;
                        height: 20px;
                        margin:0;
                        margin-right: 20px;
                        border: 2px solid #ff861a;
                        border-radius: 2px;
                    }
                }
            }
            .major-name{
                display: inline-block;
                padding-right: 20px;
                a:hover{
                    color:#ff861a;
                }
            }
        }
    }
}
.bluexx{
    color: #0081FF !important;
    font-weight: 600;
}
.puplexx{
    color: #8A49F9 !important;
    font-weight: 600;
}
}
a{
    color: #333;
}
</style>
